import { NgModule } from '@angular/core';
import { LogoutComponent } from './logout.component';

@NgModule({
    declarations: [
        LogoutComponent,
    ]
})
export class LogoutModule {}
